export const CONTAINER_SIZE = 340;

export const TILE_COUNT_PER_DIMENSION = 4;

export const MERGE_ANIMATION_DURATION = 100;

export const MOVE_ANIMATION_DURATION = 200;

export const ACTIONS = {
    CLEAN_UP: 'CLEAN_UP',
    CREATE_TILE: 'CREATE_TILE',
    MOVE_UP: 'MOVE_UP',
    MOVE_DOWN: 'MOVE_DOWN',
    MOVE_LEFT: 'MOVE_LEFT',
    MOVE_RIGHT: 'MOVE_RIGHT',
}